import styled from "styled-components";
import { motion } from "framer-motion";

export const FeaturedLabel = styled.h3`
  font-family: "Space Grotesk", sans-serif;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.text_muted};
  margin-bottom: 22px;
`;

export const FeaturedGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
  margin-bottom: 64px;
`;

export const FilterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  padding: 6px;
  border-radius: 100px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  width: max-content;
  margin: 0 0 40px;

  @media (max-width: 640px) {
    width: 100%;
  }
`;

export const FilterButton = styled.button`
  position: relative;
  padding: 10px 18px;
  border: none;
  background: transparent;
  color: ${({ $active, theme }) => ($active ? theme.text_primary : theme.text_secondary)};
  font-size: 13.5px;
  font-weight: 500;
  border-radius: 100px;
  cursor: pointer;
  z-index: 1;
  white-space: nowrap;
`;

export const FilterPill = styled(motion.div)`
  position: absolute;
  inset: 0;
  background: rgba(139, 124, 255, 0.16);
  border: 1px solid rgba(139, 124, 255, 0.3);
  border-radius: 100px;
  z-index: 0;
`;

export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 22px;
`;
